import {ACTION_TYPES} from '../../actions/admin/interventionallocation';

const initialState = {
  list: [],
};

export const interventionallocation = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_ALL:
      return {
        ...state,
        list: [...action.payload],
      };
    case ACTION_TYPES.CREATE:
      return {
        ...state,
        list: [...state.list, action.payload],
      };
    case ACTION_TYPES.UPDATE:
      return {
        ...state,
        list: state.list.map((x) =>
          x.id === action.payload.id ? action.payload : x,
        ),
      };
    case ACTION_TYPES.DELETE:
      return {
        ...state,
        list: state.list.filter((x) => x.id !== action.payload),
      };
    default:
      return state;
  }
};

export const selectInterventionalLocations = (state) =>
  state.interventionallocation.list;

export const selectInterventionalLocationsControlList = (state) =>
  state.interventionallocation.list.map((x) => ({
    value: x?.id,
    text: x?.name,
  })) || [];
